import {
    Link,
    type LinkSize,
    type LinkProps
} from "@/libraries/design/components/link/src/link.tsx";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { useLocalizedPartnerDirectoryHref } from "@/libraries/web-framework/src/localization/use-localized-partnerdirectory.ts";

export type UniformLinkProps = LinkProps & {
    mobileSize?: LinkSize;
    tabletSize?: LinkSize;
    desktopSize?: LinkSize;
    xlDesktopSize?: LinkSize;
};

export const UniformLink = (props: UniformLinkProps) => {
    let localizedHref = useLocalizedHref(props.href);

    const localizedPartnerDirectoryUrl = useLocalizedPartnerDirectoryHref(
        props.href
    );
    if (props.href !== localizedPartnerDirectoryUrl) {
        localizedHref = localizedPartnerDirectoryUrl;
    }

    return (
        <Link
            {...props}
            responsiveSize={
                props.mobileSize &&
                props.tabletSize &&
                props.desktopSize &&
                props.xlDesktopSize && {
                    mobile: props.mobileSize,
                    tablet: props.tabletSize,
                    desktop: props.desktopSize,
                    xl_desktop: props.xlDesktopSize
                }
            }
            aria-label={props.text}
            href={localizedHref}
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "link",
                "data-event": "clicked"
            }}
        />
    );
};

export default UniformLink;
